var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "MenuIcon",
  x: "0px",
  y: "0px",
  viewBox: "0 0 116 114.7",
  style: {
    enableBackground: "new 0 0 116 114.7"
  },
  xmlSpace: "preserve",
  className: "open",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "circle-one",
  className: "menu-circle",
  cx: 12.7,
  cy: 12.3,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-two",
  className: "menu-circle",
  cx: 58.2,
  cy: 12.3,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-three",
  className: "menu-circle",
  cx: 103.7,
  cy: 12.3,
  r: 12.3
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "circle-four",
  className: "menu-circle",
  cx: 12.7,
  cy: 57.3,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-five",
  className: "menu-circle",
  cx: 58.2,
  cy: 57.3,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-six",
  className: "menu-circle",
  cx: 103.7,
  cy: 57.3,
  r: 12.3
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "circle-seven",
  className: "menu-circle",
  cx: 12.7,
  cy: 102.4,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-eight",
  className: "menu-circle",
  cx: 58.2,
  cy: 102.4,
  r: 12.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle-nine",
  className: "menu-circle",
  cx: 103.7,
  cy: 102.4,
  r: 12.3
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MenuIcon.8ed1b248.svg";
export { ForwardRef as ReactComponent };